import { Building, DeviceWithoutLegacyPassword } from "../generated/types";

export const getDevicesForBuilding = (
  building: Building,
  devices: DeviceWithoutLegacyPassword[]
): DeviceWithoutLegacyPassword[] => {
  const deviceIds = new Set(building.device ?? []);
  return devices.filter((device) => deviceIds.has(device.id));
};

export const getDeviceDisplayName = (
  device: DeviceWithoutLegacyPassword
): string => device.name?.trim() || device.uuid;
